package com.neurobs.ccabserver.administrator.components

import com.neurobs.ccab.{CCABServer, SessionSearchData, SessionSearchResultData}
import com.neurobs.errors.Result
import com.neurobs.react.{CardContentProvider, Link, Table, TableCell, TableHeader, TableRow}
import com.neurobs.react.CardContentProvider.{Delegate, idCounter}
import com.neurobs.js.util.StringUtilities.dateString
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.ReactElement
import slinky.web.html.div

import scala.concurrent.Future

@react object ResultsSubjectList {
	case class Props
	(
		data: SessionSearchResultData,
		delegate: Delegate,
		dataPassword: String
	)
	val component = FunctionalComponent[Props] { props =>
		val subjects = props.data.sessions.groupBy(_.session.accountSubjectId)
		val chronSubjects = subjects.toVector.map(s => (s._2.map(_.session.startTime.instant.getEpochSecond).min, s._2)).sortBy(_._1).map(_._2)

		if (chronSubjects.isEmpty) div("There have been no sessions for this study.")
		else {
			Table(
				TableHeader(
					TableCell("Reporting ID"), TableCell("Name/ID"), TableCell("Last Session")
				),
				chronSubjects map { s =>
					val first = s.head
					val latest = s.maxBy(_.session.startTime).session.startTime
					val link = Link(
						caption = first.session.reportingId.noBracketsString,
						onClick = () => {
							props.delegate.addCard(card = new ResultsSubjectProvider(accountId = first.session.accountId, accountSubjectId = first.session.accountSubjectId, reportingId = first.session.reportingId, dataPassword = props.dataPassword), afterThis = true)
						}
					)

					TableRow(
						TableCell(link),
						TableCell(first.identity.map(_.displayName(default = "")).getOrElse("")),
						TableCell(dateString(latest))
					).withKey(key = first.session.accountSubjectId.toString)
				}
			)
		}
	}
}

class ResultsSubjectListProvider(accountId: Long, studyId: Long, studyName: String, dataPassword: String) extends CardContentProvider {
	override def title: String = s"Study $studyName Subjects"
	override def canClose: Boolean = true
	override def refreshFunction: Option[CCABServer => Future[Result[AnyRef]]] = Some { server =>
		val search = SessionSearchData(accountId = Some(accountId), studyId = Some(studyId), dataPassword = Some(dataPassword))
		server.getTestSessionViews(search)._2
	}
	override def content(d: Delegate, contentData: Option[AnyRef]): ReactElement = ResultsSubjectList(data = contentData.get.asInstanceOf[SessionSearchResultData], delegate = d, dataPassword = dataPassword)
}